<!-- Button -->
<button
    mat-icon-button
    [attr.aria-label]="languageService.label(activeLang)"
    [matMenuTriggerFor]="languages">
    <ng-container
        *ngTemplateOutlet="
            flagImage;
            context: { $implicit: activeLang }
        "></ng-container>
</button>

<!-- Language menu -->
<mat-menu
    [xPosition]="'before'"
    #languages="matMenu">
    @for (lang of languageService.languages(); track lang.id) {
        <button
            mat-menu-item
            [attr.aria-current]="lang.id === activeLang"
            (click)="setActiveLang(lang.id)">
            <span class="flex w-full min-w-44 items-center gap-3">
                <ng-container
                    *ngTemplateOutlet="
                        flagImage;
                        context: { $implicit: lang.id }
                    "></ng-container>
                <span
                    class="flex-auto"
                    [class.font-semibold]="lang.id === activeLang"
                    [attr.lang]="lang.id"
                    >{{ languageService.label(lang.id) }}</span
                >
                @if (lang.id === activeLang) {
                    <lucide-icon
                        class="text-primary"
                        [img]="CheckIcon"
                        [size]="16"></lucide-icon>
                }
            </span>
        </button>
    }
</mat-menu>

<!-- Flag image template -->
<ng-template
    let-lang
    #flagImage>
    @if (languageService.flag(lang); as flag) {
        <span class="relative w-6 shrink-0 shadow rounded-sm overflow-hidden">
            <span
                class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"></span>
            <img
                class="w-full"
                [src]="'assets/images/flags/' + flag + '.svg'"
                [alt]="languageService.label(lang)" />
        </span>
    } @else {
        <span
            class="inline-flex h-[18px] w-6 shrink-0 items-center justify-center rounded-sm bg-gray-200 text-[9px] font-semibold tracking-wide text-gray-700"
            >{{ lang | uppercase }}</span
        >
    }
</ng-template>
